import { NexaAskRequest } from '../types/askNexa';

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Validates the structure of a NexaAskRequest
 * @param request - The request object to validate
 * @returns ValidationResult with valid flag and optional error message
 */
export function validateAskRequest(request: any): ValidationResult {
  // Check if request exists
  if (!request || typeof request !== 'object') {
    return {
      valid: false,
      error: 'Request must be a valid object',
    };
  }

  // Check required fields
  if (!request.diagnostic || typeof request.diagnostic !== 'object') {
    return {
      valid: false,
      error: 'Request must have a valid "diagnostic" object',
    };
  }

  if (!request.diagnostic.type || typeof request.diagnostic.type !== 'string') {
    return {
      valid: false,
      error: 'Request must have a valid "diagnostic.type" field',
    };
  }

  if (!request.diagnostic.params || typeof request.diagnostic.params !== 'object') {
    return {
      valid: false,
      error: 'Request must have a valid "diagnostic.params" object',
    };
  }

  if (!request.query || typeof request.query !== 'string') {
    return {
      valid: false,
      error: 'Request must have a valid "query" string',
    };
  }

  // Optional: validate metadata if present
  if (request.metadata !== undefined) {
    if (typeof request.metadata !== 'object') {
      return {
        valid: false,
        error: 'Metadata must be an object if provided',
      };
    }
  }

  return {
    valid: true,
  };
}
